var styleDataHash = 'd62db109';  
export const injectCss = (() => {
  var css = `.KcjE2{align-items:center;color:#fff;display:flex;height:100%;justify-content:center;position:absolute;top:0;width:100%}[dir] .KcjE2{background:rgba(0,0,0,.5);text-align:center}.DoANG{height:20px;width:20px}[dir] .p2YCh{margin-bottom:56px}._3Wvdz{font-size:16px;line-height:24px;position:absolute}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "error": "KcjE2",
  "errorIcon": "DoANG",
  "errorIconWithMessage": "p2YCh",
  "errorMsg": "_3Wvdz"
};